import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { DeviceBehfa_ChangeOperation_Interface } from 'src/app/Interface/DeviceBehfa_ChangeOperation_Interface';
import { DeviceBehfa_Interface } from 'src/app/Interface/DeviceBehfa_Interface';
import { DeviceBehfaService } from 'src/app/Service/DeviceBehfa/DeviceBehfa.service';

@Component({
  selector: 'app-DeviceBehfaChangeOperation',
  templateUrl: './DeviceBehfaChangeOperation.component.html',
  styleUrls: ['./DeviceBehfaChangeOperation.component.scss']
})
export class DeviceBehfaChangeOperationComponent implements OnInit {

  @Input() deviceBehfa_Innner:DeviceBehfa_Interface
  @Output() OnBack_DeviceBehfa_Action = new EventEmitter<number>();
  Token:String=""
  Proccessing:boolean=false
  page:number=0

  ngOnChanges(changes: SimpleChanges): void {
    this.Token=localStorage.getItem('Daro_User_Token');
    this.Read_ChangeOperation()


  }

  constructor(
    private DeviceBehfa_Service:DeviceBehfaService,
  ) { }

  ngOnInit() {
  }


  OnSet_Back_DeviceBehfa(){
    this.OnBack_DeviceBehfa_Action.emit(-1);
  }


  DataList_ChangeOperation:Array<DeviceBehfa_ChangeOperation_Interface>=[]
  Read_ChangeOperation(){
    this.Proccessing=true
    this.DeviceBehfa_Service.GetChangeOperation(this.Token,this.deviceBehfa_Innner.id).subscribe(
      data=>{
        this.Proccessing=false
        this.DataList_ChangeOperation=data
      },error=>{
        localStorage.clear()
        location.reload();
      }
    )
  }

}
